import React from "react"
import { Grid, Button } from "semantic-ui-react"
import { Link } from "react-router-dom"
import "./Introduction.css"

export const Introduction = ({ continueUrl }) => (
  <Grid centered>
    <Grid.Row>
      <Grid.Column textAlign="center">
        <h2 className="PlanIntroduction__Heading">Let's Plan Your Future!</h2>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column
        className="PlanIntroduction__Description"
        width={14}
        textAlign="center"
      >
        <p>
          The journey to clarity, confidence and control really gets exciting
          when we work together to design the future of your dreams.
        </p>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column textAlign="center">
        <div className="PlanIntroduction__VideoHolder">
          <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
            <iframe
              title="Introduction Video"
              src="https://player.vimeo.com/video/238652129?title=0&byline=0&portrait=0"
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%"
              }}
              frameBorder="0"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              allowFullScreen={true}
            />
          </div>
          <script src="https://player.vimeo.com/api/player.js" />
        </div>
        <div
          className="PlanIntroduction__Skip"
          style={{ paddingBottom: "5em" }}
        >
          <Link to={continueUrl} className="navlink">
            <Button primary size="big" data-testid="continue">
              Let's Do It!
            </Button>
          </Link>
        </div>
      </Grid.Column>
    </Grid.Row>
  </Grid>
)
